import { render, staticRenderFns } from "./PurchaseInboxreaderSettings.vue?vue&type=template&id=057d6c8e&scoped=true"
import script from "./PurchaseInboxreaderSettings.vue?vue&type=script&lang=ts"
export * from "./PurchaseInboxreaderSettings.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInboxreaderSettings.vue?vue&type=style&index=0&id=057d6c8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d6c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057d6c8e')) {
      api.createRecord('057d6c8e', component.options)
    } else {
      api.reload('057d6c8e', component.options)
    }
    module.hot.accept("./PurchaseInboxreaderSettings.vue?vue&type=template&id=057d6c8e&scoped=true", function () {
      api.rerender('057d6c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/PurchaseInboxreaderSettings.vue"
export default component.exports